module.exports = __webpack_public_path__ + "img/header.1b6b8448.png";